import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  Output,
  ViewEncapsulation
} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {debounceTime, filter} from 'rxjs/operators';
import {svgNames} from '../svg/svgItems';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnDestroy, AfterViewInit {
  @Input() title: string;
  @Input() searchValue: string;
  @Input() debounceTime: number = 500;
  @Output() onSearch: EventEmitter<string> = new EventEmitter<string>();

  public SVG_NAMES = svgNames;

  private searchTerm: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private prevSearchValue: string = '';

  ngAfterViewInit() {
    this.searchTerm.pipe(
      filter(value => value !== null),
      debounceTime(this.debounceTime)
    ).subscribe(
      value => {
        if (value.trim() === this.prevSearchValue && value.trim() !== '') {
          return;
        }
        this.prevSearchValue = value.trim();
        value = value.replace(/\\+/gm, '\\\\');
        this.onSearch.emit(value.replace(/\s+/g, ' ').trim());
      }
    );
  }
  public handleSearch(value: string) {
    if (this.searchValue === null) {
      this.prevSearchValue = '';
    }
    this.searchTerm.next(value);
  }

  ngOnDestroy() {
    this.searchTerm.unsubscribe();
  }
}
